import {DatabaseCode, toDatabaseCode} from "./database-code";

export type FleetAssetCapabilityType = DatabaseCode

const freightHaul: FleetAssetCapabilityType = {
  code: 'FREIGHT_HAUL',
  displayValue: {
    id: 'common.entity.fleetassetcapabilitytype.freighthaul',
    defaultMessage: 'Freight Haul',
  },
};

const snowPlow: FleetAssetCapabilityType = {
  code: 'SNOW_PLOW',
  displayValue: {
    id: 'common.entity.fleetassetcapabilitytype.snowplow',
    defaultMessage: 'Snow Plow',
  },
};

export const fleetAssetCapabilityType = {
  freightHaul,
  snowPlow
};

export const fleetAssetCapabilityTypes = Object.values(fleetAssetCapabilityType);

export const toFleetAssetCapabilityType = (code: string): FleetAssetCapabilityType => toDatabaseCode(code, fleetAssetCapabilityTypes);
export const toFleetAssetCapabilityTypeSafely = (code: string | undefined): FleetAssetCapabilityType | undefined => code ? toDatabaseCode(code, fleetAssetCapabilityTypes) : undefined;
